import React, { useEffect } from "react";
import { observer } from "mobx-react";

import { useRootAppStore } from "@hooks";
import { BetDisplay, BetListDisplay } from "./display/components";

export default observer(function MiniMyBets() {
	const myBetsViewStore = useRootAppStore().myBetsViewStore;

	useEffect(() => {
		myBetsViewStore.onInitialize();
		return () => myBetsViewStore.onDispose();
	}, []);

	if (myBetsViewStore.isBetOpen) {
		return <BetDisplay myBetsViewStore={myBetsViewStore} />;
	}

	return <BetListDisplay myBetsViewStore={myBetsViewStore} />;
});
